import {Component} from '@angular/core';
import {ApiService} from './services/api-service/api.service';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent {
 public metaTitle = 'lightstudio';

 constructor(private apiService: ApiService,private router: Router,private titleService: Title,private meta: Meta) {
  this.apiService.getPages().subscribe(value => {
    this.titleService.setTitle(value['data'][1]['meta_title']);
  });


  this.router.events.subscribe((event: Event) => {
    
    if (event instanceof NavigationStart) {
        switch(event.url){
          case '/rules': 
          this.apiService.getPages().subscribe(value => {
            this.titleService.setTitle(value['data'][0]['meta_title']);
            this.meta.updateTag({name: 'description', content: value['data'][0]['meta_description']});
            this.meta.updateTag({name: 'keywords', content: value['data'][0]['meta_keywords']});
        });
          break;
          case '/': 
          this.apiService.getPages().subscribe(value => {
            this.titleService.setTitle(value['data'][1]['meta_title']);
            this.meta.updateTag({name: 'description', content: value['data'][1]['meta_description']});
            this.meta.updateTag({name: 'keywords', content: value['data'][1]['meta_keywords']});
        });
          break;
          case '/contacts': 
          this.apiService.getPages().subscribe(value => {
            this.titleService.setTitle(value['data'][2]['meta_title']);
            this.meta.updateTag({name: 'description', content: value['data'][2]['meta_description']});
            this.meta.updateTag({name: 'keywords', content: value['data'][2]['meta_keywords']});
        });
          break;
          case '/portfolio': 
          this.apiService.getPages().subscribe(value => {
            this.titleService.setTitle(value['data'][3]['meta_title']);
            this.meta.updateTag({name: 'description', content: value['data'][3]['meta_description']});
            this.meta.updateTag({name: 'keywords', content: value['data'][3]['meta_keywords']});
        });
          break;
          default: 
          this.titleService.setTitle('Фотостудия Киев, Интерьерная фотостудия, LIGHT STUDIO PHOTO SPACE.');
          break;
        }
    }

    if (event instanceof NavigationEnd) {
       
    }

    if (event instanceof NavigationError) {
        // Hide loading indicator

        // Present error to user
        // console.log(event.error);
    }
});
  
}   

 

}

